import { PAGE_CACHE_HEADERS } from "@/lib/ssrCache";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { ensureExists } from "@/lib/ensureExists";
import { productHubSlugs } from "@/lib/productHubConfig";
import GenericProduct from "@/pages/GenericProduct";
import NotFound from "@/pages/NotFound";
import { redirectIfPruned } from "@/lib/prunedRedirect";

// Hubs with dedicated product pages have their own static route directories.
const DEDICATED = ["lawn-mowers", "generators", "chainsaws", "pressure-washers"];

const SlugProduct = () => {
  const { slug } = Route.useParams();
  if (productHubSlugs.includes(slug) && !DEDICATED.includes(slug)) {
    return <GenericProduct hubSlug={slug} />;
  }
  return <NotFound />;
};

export const Route = createFileRoute("/$slug/$productSlug")({
  beforeLoad: async ({ params }) => {
    if (!productHubSlugs.includes(params.slug) || DEDICATED.includes(params.slug)) throw notFound();
    await redirectIfPruned(params.slug, params.productSlug);
    await ensureExists("products", params.productSlug, { product_type: params.slug });
  },
  component: SlugProduct,
  headers: () => PAGE_CACHE_HEADERS,
  head: ({ params }) => {
    const canonicalUrl = "https://www.garden-review.co.uk" + `/${params.slug}/${params.productSlug}`;
    return {
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
});
